import { axios } from '@/services/axios';

const getEngineLocations = async (accountScope) => {
    const res = await axios.get('/EngineLocations', {
        headers: {
            'X-RequestScope': accountScope,
        },
    });
    return res.data;
};

export default getEngineLocations;
